/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Heading, Text, theme } from "@nordcloud/gnui";
import { CloudProviderType, Maybe } from "~/generated/graphql";
import { AccountData } from "~/components/Forms/DiscoveryRulesForm";
import { AccountStatusIcon } from "../Icons";

type AccountSelectorItemListProps = {
  items: AccountData[];
  onSubmit: (id: string, provider?: Maybe<CloudProviderType>) => void;
};

export function AccountSelectorItemList({
  items,
  onSubmit,
}: AccountSelectorItemListProps) {
  return (
    <>
      {items.map(({ nid, name, providerType, cloudStatusV2: cloudStatus }) => (
        <ItemContainer key={nid} onClick={() => onSubmit(nid, providerType)}>
          <AccountStatusIcon status={cloudStatus ?? undefined} />
          <div>
            <Heading level={4}>{name}</Heading>
            <Text size="sm" tag="div" color={theme.color.text.text02}>
              {nid}
            </Text>
          </div>
        </ItemContainer>
      ))}
    </>
  );
}

const ItemContainer = styled.div`
  padding: ${theme.spacing.spacing02};
  border-bottom: 1px solid ${theme.color.border.border01};
  text-align: left;
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing.spacing02};

  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui03};
  }
`;
